module.exports = __webpack_public_path__ + "img/spaceBg.8d6a71dd.png";